import { useEffect, useState, useCallback } from 'react';
import AppHeader from '../../components/AppHeader';
import { feedbackApi, FEEDBACK_TYPES } from '../../api';

const TYPE_SHORT = { bug: '🐞 Chyba', idea: '💡 Návrh', question: '❓ Dotaz', confusing: '😕 Matoucí', other: '➕ Jiné' };

export default function FeedbackInbox() {
  const [rows, setRows] = useState([]);
  const [statusFilter, setStatusFilter] = useState('new');
  const [typeFilter, setTypeFilter] = useState('');

  const params = () => ({ ...(statusFilter ? { status: statusFilter } : {}), ...(typeFilter ? { type: typeFilter } : {}) });
  const load = useCallback(() => feedbackApi.list(params()).then((r) => setRows(r.data)).catch(() => setRows([])), [statusFilter, typeFilter]);
  useEffect(() => { load(); }, [load]);

  const toggleResolved = async (f) => {
    await feedbackApi.setStatus(f.id, f.status === 'resolved' ? 'new' : 'resolved');
    load();
  };

  const fmt = (d) => d ? new Date(d).toLocaleString('cs-CZ', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';

  return (
    <div>
      <AppHeader subtitle="Zpětná vazba" />
      <div className="container" style={{ paddingTop: 24, maxWidth: 760 }}>
        <div className="flex" style={{ justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 12 }}>
          <div className="flex gap-8">
            <select className="form-input" style={{ width: 'auto', padding: '4px 8px' }} value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
              <option value="">Vše</option>
              <option value="new">Nové</option>
              <option value="resolved">Vyřešené</option>
            </select>
            <select className="form-input" style={{ width: 'auto', padding: '4px 8px' }} value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
              <option value="">Všechny typy</option>
              {Object.entries(FEEDBACK_TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
          {rows.length > 0 && <a className="btn btn-outline btn-sm" href={feedbackApi.csvUrl(params())} download>⬇ CSV</a>}
        </div>

        {rows.length === 0 ? (
          <p className="text-muted text-center" style={{ padding: 24 }}>Žádná zpětná vazba.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {rows.map((f) => (
              <div key={f.id} className="card" style={{ opacity: f.status === 'resolved' ? 0.6 : 1 }}>
                <div className="flex" style={{ justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                  <div style={{ flex: 1 }}>
                    <div className="flex gap-8" style={{ alignItems: 'center', flexWrap: 'wrap' }}>
                      <span className="badge badge-in">{TYPE_SHORT[f.type] || f.type}</span>
                      {f.status === 'resolved' && <span className="badge badge-out">vyřešeno</span>}
                      <span className="text-muted" style={{ fontSize: '0.78rem' }}>{fmt(f.created_at)}</span>
                    </div>
                    <p style={{ margin: '8px 0', whiteSpace: 'pre-wrap' }}>{f.message}</p>
                    <div className="text-muted" style={{ fontSize: '0.78rem' }}>
                      📍 {f.screen_title || f.screen || '—'}{f.screen && f.screen_title ? ` (${f.screen})` : ''}
                      {' · '}{(f.first_name || f.last_name) ? `${f.first_name || ''} ${f.last_name || ''}`.trim() : 'neznámý'}
                      {f.role ? ` (${f.role})` : ''}{f.device ? ` · ${f.device}` : ''}{f.app_version ? ` · v${f.app_version}` : ''}
                    </div>
                  </div>
                  <button className={`btn btn-sm ${f.status === 'resolved' ? 'btn-outline' : 'btn-primary'}`} onClick={() => toggleResolved(f)}>
                    {f.status === 'resolved' ? 'Otevřít' : '✓ Vyřešeno'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
